module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "new-layout"
  }, [(_vm.isMobile && _vm.showOverlayMobile) ? _c('div', {
    staticClass: "action-bar"
  }, [_vm._m(0), _vm._v(" "), _c('span', {
    staticClass: "close-alert special-font",
    on: {
      "click": _vm.fecharActionBar
    }
  }, [_c('img', {
    staticClass: "closeIcon",
    attrs: {
      "src": require("../../assets/img/icons/close.svg")
    }
  })])]) : _vm._e(), _vm._v(" "), (_vm.companies) ? _c('div', {
    staticClass: "container container-companies",
    staticStyle: {
      "z-index": "9997"
    }
  }, [_c('div', {
    staticClass: "dropdown drop-full"
  }, [_c('button', {
    staticClass: "form-control dropdown-toggle btn-dropdown drop-dark drop-word-wrap",
    attrs: {
      "type": "button",
      "id": "empresas",
      "data-toggle": "dropdown",
      "aria-haspopup": "true",
      "aria-expanded": "true"
    }
  }, [_c('span', {
    staticClass: "selected"
  }, [_vm._v(_vm._s(_vm.currentUser.company.companyName) + " ")]), _vm._v(" -\n        "), _c('span', {
    directives: [{
      name: "mask-cpf-cnpj",
      rawName: "v-mask-cpf-cnpj"
    }]
  }, [_vm._v(_vm._s(_vm.currentUser.taxIdNumber))]), _vm._v(" "), _c('i', {
    staticClass: "icon-arrow-down-dropdown"
  })]), _vm._v(" "), _c('ul', {
    staticClass: "dropdown-menu",
    attrs: {
      "aria-labelledby": "empresas"
    }
  }, _vm._l((_vm.companies), function(company, index) {
    return _c('li', {
      key: index
    }, [_c('a', {
      class: {
        active: company.moveMaisId == _vm.currentUser.moveMaisId
      },
      on: {
        "click": function($event) {
          return _vm.changeUser(company.moveMaisId)
        }
      }
    }, [_c('span', {
      staticClass: "word-wrap"
    }, [_vm._v(_vm._s(company.companyName) + " ")]), _vm._v(" -\n            "), _c('span', {
      directives: [{
        name: "mask-cpf-cnpj",
        rawName: "v-mask-cpf-cnpj"
      }]
    }, [_vm._v(" " + _vm._s(company.taxIdNumber))])])])
  }), 0)])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "tabs-section hidden-print",
    class: {
      fixed: _vm.scrolling
    },
    staticStyle: {
      "z-index": "9997"
    },
    attrs: {
      "id": "tabs-section"
    }
  }, [(_vm.showOverlay && !_vm.isMobile) ? _c('div', {
    staticClass: "action-bar"
  }, [_vm._m(1), _vm._v(" "), _c('span', {
    staticClass: "close-alert special-font",
    on: {
      "click": _vm.fecharActionBar
    }
  }, [_c('img', {
    staticClass: "closeIcon",
    attrs: {
      "src": require("../../assets/img/icons/close.svg")
    }
  })])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, [_c('router-link', {
    staticClass: "tab-item",
    attrs: {
      "to": {
        name: 'home'
      }
    }
  }, [(!_vm.scrolling) ? _c('img', {
    staticClass: "logo-img",
    attrs: {
      "src": require("../../../static/Logo_Move_Mais_Vertical_2026.svg"),
      "alt": "Logo Move Mais TAG",
      "width": "130"
    }
  }) : _c('img', {
    staticClass: "logo-img",
    attrs: {
      "src": require("../../../static/Logo_Move_Mais_Vertical_Branco_2026.svg"),
      "alt": "Logo Move Mais TAG",
      "width": "130"
    }
  })]), _vm._v(" "), _c('ul', {
    staticClass: "nav nav-tabs"
  }, [_c('li', {
    attrs: {
      "role": "presentation"
    }
  }, [_c('router-link', {
    staticClass: "tab-item",
    attrs: {
      "to": {
        name: 'plans'
      }
    }
  }, [_c('i', {
    staticClass: "icon-padnote"
  }), _vm._v(" "), _c('span', [_vm._v("Planos")])])], 1), _vm._v(" "), _c('li', {
    attrs: {
      "role": "presentation"
    }
  }, [_c('router-link', {
    staticClass: "tab-item",
    attrs: {
      "to": {
        name: 'requests'
      }
    }
  }, [_c('i', {
    staticClass: "icon-bell"
  }), _vm._v(" "), _c('span', [_vm._v("Pedidos")])])], 1), _vm._v(" "), _c('li', {
    attrs: {
      "role": "presentation"
    }
  }, [_c('router-link', {
    staticClass: "tab-item",
    attrs: {
      "to": {
        name: 'tag-activate'
      }
    }
  }, [_c('i', {
    staticClass: "icon-active-tag"
  }), _vm._v(" "), _c('span', [_vm._v("Ativar TAG")])])], 1), _vm._v(" "), _c('li', {
    attrs: {
      "role": "presentation"
    }
  }, [_c('router-link', {
    staticClass: "tab-item",
    attrs: {
      "to": {
        name: 'routing'
      }
    }
  }, [_c('i', {
    staticClass: "icon-routing"
  }), _vm._v(" "), _c('span', [_vm._v("Viagem")])])], 1), _vm._v(" "), (false) ? _c('li', {
    attrs: {
      "role": "presentation"
    }
  }, [_c('router-link', {
    staticClass: "tab-item",
    attrs: {
      "to": {
        name: 'routing'
      }
    }
  }, [_c('i', {
    staticClass: "icon-key"
  }), _vm._v(" "), _c('span', [_vm._v("Rotas")])])], 1) : _vm._e(), _vm._v(" "), (_vm.refund) ? _c('li', {
    attrs: {
      "role": "presentation"
    }
  }, [_c('router-link', {
    staticClass: "tab-item",
    attrs: {
      "to": {
        name: 'refund'
      }
    }
  }, [_c('i', {
    staticClass: "icon-road"
  }), _vm._v(" "), _c('span', [_vm._v("Contestação")])])], 1) : _vm._e(), _vm._v(" "), _c('li', {
    attrs: {
      "role": "presentation"
    }
  }, [_c('router-link', {
    staticClass: "tab-item",
    attrs: {
      "to": {
        name: 'profile'
      }
    }
  }, [_c('i', {
    staticClass: "icon-my-data"
  }), _vm._v(" "), _c('span', [_vm._v("Meus dados")])])], 1), _vm._v(" "), (_vm.is2FA) ? _c('li', {
    attrs: {
      "role": "presentation"
    }
  }, [_c('router-link', {
    staticClass: "tab-item",
    attrs: {
      "to": {
        name: 'password-change-confirmation'
      }
    }
  }, [_c('i', {
    staticClass: "icon-key"
  }), _vm._v(" "), _c('span', [_vm._v("Alterar senha")])])], 1) : _vm._e(), _vm._v(" "), (!_vm.is2FA) ? _c('li', {
    attrs: {
      "role": "presentation"
    }
  }, [_c('router-link', {
    staticClass: "tab-item",
    attrs: {
      "to": {
        name: 'password-change'
      }
    }
  }, [_c('i', {
    staticClass: "icon-key"
  }), _vm._v(" "), _c('span', [_vm._v("Alterar senha")])])], 1) : _vm._e(), _vm._v(" "), _c('li', {
    staticClass: "pull-right",
    attrs: {
      "role": "presentation"
    }
  }, [_c('a', {
    staticClass: "tab-item",
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": _vm.logout
    }
  }, [_c('i', {
    staticClass: "icon-logout"
  }), _vm._v(" "), _c('span', [_vm._v("Sair")])])])])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "tabs-section hidden-print mob",
    class: {
      fixed: _vm.scrolling
    },
    staticStyle: {
      "z-index": "9997"
    },
    attrs: {
      "id": "tabs-section"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('router-link', {
    staticClass: "tab-item",
    attrs: {
      "to": {
        name: 'home'
      }
    }
  }, [_c('img', {
    staticClass: "logo-img",
    attrs: {
      "src": require("../../../static/Logo_Move_Mais_Horizontal_2026.svg"),
      "alt": "Logo Move Mais TAG",
      "width": "210"
    }
  })]), _vm._v(" "), _c('ul', {
    staticClass: "nav nav-tabs"
  }, [_c('li', {
    staticClass: "pull-right",
    attrs: {
      "role": "presentation"
    }
  }, [_c('a', {
    staticClass: "tab-item",
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": _vm.logout
    }
  }, [_c('i', {
    staticClass: "icon-logout"
  }), _vm._v(" "), _c('span', [_vm._v("Sair")])])])])], 1)]), _vm._v(" "), _c('router-view', {
    class: {
      'fix-footer': _vm.fixFooter
    }
  }), _vm._v(" "), (!_vm.fixFooter) ? _c('div', {
    staticClass: "footer-mobile hidden-print"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'plans'
      }
    }
  }, [_c('div', {
    staticClass: "footer-mobile-link word-wrap"
  }, [_c('i', {
    staticClass: "icon-padnote"
  }), _vm._v("\n        Planos\n      ")])]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": {
        name: 'requests'
      }
    }
  }, [_c('div', {
    staticClass: "footer-mobile-link word-wrap"
  }, [_c('i', {
    staticClass: "icon-bell"
  }), _vm._v("\n        Pedidos\n      ")])]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": {
        name: 'tag-activate'
      }
    }
  }, [_c('div', {
    staticClass: "footer-mobile-link word-wrap"
  }, [_c('i', {
    staticClass: "icon-active-tag"
  }), _vm._v("\n        Ativar TAG\n      ")])]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": {
        name: 'routing'
      }
    }
  }, [_c('div', {
    staticClass: "footer-mobile-link word-wrap"
  }, [_c('i', {
    staticClass: "icon-routing"
  }), _vm._v("\n        Viagem\n      ")])]), _vm._v(" "), _c('div', {
    staticClass: "dropup footer-mobile-link"
  }, [_vm._m(2), _vm._v(" "), _c('ul', {
    staticClass: "dropdown-menu dropdown-menu-right"
  }, [_c('li', {
    staticClass: "divider",
    attrs: {
      "role": "separator"
    }
  }), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": {
        name: 'notification'
      }
    }
  }, [_c('i', {
    staticClass: "icon-mail icon-footer-dropup"
  }), _vm._v("\n            Notificações\n          ")])], 1), _vm._v(" "), _c('li', {
    staticClass: "divider",
    attrs: {
      "role": "separator"
    }
  }), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": {
        name: 'profile'
      }
    }
  }, [_c('i', {
    staticClass: "icon-my-data icon-footer-dropup"
  }), _vm._v("\n            Meus Dados\n          ")])], 1), _vm._v(" "), _c('li', {
    staticClass: "divider",
    attrs: {
      "role": "separator"
    }
  }), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": {
        name: 'password-change'
      }
    }
  }, [_c('i', {
    staticClass: "icon-key icon-footer-dropup"
  }), _vm._v("\n            Alterar senha\n          ")])], 1), _vm._v(" "), _c('li', {
    staticClass: "divider",
    attrs: {
      "role": "separator"
    }
  }), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": _vm.logout
    }
  }, [_c('i', {
    staticClass: "icon-logout icon-footer-dropup"
  }), _vm._v("\n            Sair\n          ")])])])])], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "bottom-wrap"
  }), _vm._v(" "), _vm._m(3)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "action-header-txt"
  }, [_c('img', {
    staticClass: "icon-exclamation",
    attrs: {
      "src": require("../../assets/img/icons/exclamation-triangle-fill.svg")
    }
  }), _vm._v("\n      Trocou a placa do seu veículo para o padrão\n      "), _c('span', {
    staticClass: "special-font"
  }, [_vm._v("Mercosul")]), _vm._v("? Não esqueça de atualizar os\n      dados veiculares da sua TAG.\n      "), _c('span', {
    staticClass: "special-font"
  }, [_vm._v("Evite multas!")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "action-header-txt"
  }, [_c('img', {
    staticClass: "icon-exclamation",
    attrs: {
      "src": require("../../assets/img/icons/exclamation-triangle-fill.svg")
    }
  }), _vm._v("\n        Trocou a placa do seu veículo para o padrão\n        "), _c('span', {
    staticClass: "special-font"
  }, [_vm._v("Mercosul")]), _vm._v("? Não esqueça de atualizar\n        os dados veiculares da sua TAG.\n        "), _c('span', {
    staticClass: "special-font"
  }, [_vm._v("Evite multas!")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "dropdown-toggle",
    attrs: {
      "data-toggle": "dropdown",
      "aria-haspopup": "true",
      "aria-expanded": "false"
    }
  }, [_c('i', {
    staticClass: "icon-ellipsis"
  }), _vm._v("\n        Mais\n      ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('footer', {
    staticClass: "footer footer-inside"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-8 col-md-8"
  }, [_c('div', {
    staticClass: "sac-icon-circle"
  }, [_c('i', {
    staticClass: "icon-help-desk sac-icon-fix"
  })]), _vm._v(" "), _c('div', {
    staticClass: "sac-text"
  }, [_c('p', {
    staticClass: "bold"
  }, [_vm._v("central de relacionamento")]), _vm._v(" "), _c('p', [_vm._v("\n              Capitais e regiões metropolitanas\n              "), _c('span', {
    staticClass: "sac-phone-number"
  }, [_vm._v("4000 2901")])]), _vm._v(" "), _c('p', [_vm._v("\n              Demais localidades\n              "), _c('span', {
    staticClass: "sac-phone-number"
  }, [_vm._v("0800 777 1022")])]), _vm._v(" "), _c('p', [_vm._v("E-mail: "), _c('span', [_vm._v("relacionamento@movemais.com")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4 col-md-4"
  }, [_c('div', {
    staticClass: "seals"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/img/sectigo_trust_seal_sm_2x.png"),
      "alt": "Sectigo Secure Seal"
    }
  })])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// C:/Users/enzo.barros/software/azure/movemais.client/~/vue-loader/lib/template-compiler.js?id=data-v-18ad0eec!C:/Users/enzo.barros/software/azure/movemais.client/~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/account/home-account.vue
// module id = 2056
// module chunks = 1